<template>
  <component :is="currentView" :active="active"></component>
</template>

<script>
import eq from 'lodash/eq';
import { mapGetters } from 'vuex';
import WAllVirtualPerfList from '@/views/virtual/performance/group/perfinfo/components/AllVirtualPerfList';
import WDataCenterPerfTable from '@/views/performance/components/virtual/DataCenterPerfTable';
import WHostClusterPerfTable from '@/views/performance/components/virtual/HostClusterPerfTable';
import WHostPerfTable from '@/views/performance/components/virtual/HostPerfTable';
import WVmPerfTable from '@/views/performance/components/virtual/VmPerfTable';
import WStorageClusterPerfTable from '@/views/performance/components/virtual/StorageClusterPerfTable';
import WStoragePerfTable from '@/views/performance/components/virtual/StoragePerfTable';

export default {
  name: 'WPerfInfoGroup',
  components: {
    WAllVirtualPerfList,
    WDataCenterPerfTable,
    WHostClusterPerfTable,
    WHostPerfTable,
    WVmPerfTable,
    WStorageClusterPerfTable,
    WStoragePerfTable,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      currentView: null,
      loadFlag: false,
    };
  },
  computed: mapGetters(['selectedVmsObjtypeIds']),
  watch: {
    selectedVmsObjtypeIds: {
      handler(selectedList) {
        if (this.active) {
          this.loadFlag = true;
          this.changeView(selectedList);
        }
      },
    },
    active: {
      handler() {
        if (this.loadFlag) {
          this.changeView(this.selectedVmsObjtypeIds);
        }
      },
    },
  },
  methods: {
    changeView(selectedList) {
      /*
        - 선택된 장비가 하나일 경우 해당 장비의 화면 출력
        - 선택된 장비가 없거나 하나 이상일 경우 공통 화면 출력
       */
      if (this.active) {
        if (selectedList.length === 1) {
          const objtypeId = selectedList[0];
          if (eq(objtypeId, 'VDC')) {
            this.currentView = WDataCenterPerfTable.name;
          } else if (eq(objtypeId, 'VCL')) {
            this.currentView = WHostClusterPerfTable.name;
          } else if (eq(objtypeId, 'VHO')) {
            this.currentView = WHostPerfTable.name;
          } else if (eq(objtypeId, 'VVM')) {
            this.currentView = WVmPerfTable.name;
          } else if (eq(objtypeId, 'VDSC')) {
            this.currentView = WStorageClusterPerfTable.name;
          } else if (eq(objtypeId, 'VDS')) {
            this.currentView = WStoragePerfTable.name;
          }
        } else {
          this.currentView = WAllVirtualPerfList.name;
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/virtual/performance/group/perfinfo/index.vue